const download = (content, contentType, fileName) => {
	const link = document.createElement('a')
	link.href = window.URL.createObjectURL(new Blob([content], { type: contentType }))
	link.download = fileName
	link.click()
}

export default download
